module.exports = __webpack_public_path__ + "img/softwareEng.65039e4e.webp";